const Platforms = [{PlatformName: 'Instagram', PlatformID: 1}
,{PlatformName: 'Facebook', PlatformID: 2}, 
{PlatformName: 'Twitter', PlatformID: 3},
{PlatformName: 'TikTok', PlatformID: 4},
{PlatformName: 'Triller', PlatformID: 6},
{PlatformName: 'YouTube Shorts', PlatformID: 7},
{PlatformName: 'CapCut', PlatformID: 8}
]

export default Platforms;